import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { FileVm } from '../../../../shared/Models/fileVm';
import * as momentHijri from 'moment-hijri';
import { Partner } from '../../models/partner';
import { PartnerService } from '../../services/partner-service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-partner',
  templateUrl: './add-partner.component.html',
  styleUrls: ['./add-partner.component.scss'],
})
export class AddPartnerComponent implements OnInit {
  model: Partner = {} as Partner;
  formData: FormData = new FormData();
  validPhoto = false;
  isEdit = false;
  uploadThumbnail = false;
  isLoading = false;

  constructor(
    private service: PartnerService,
    private diagRef: NbDialogRef<AddPartnerComponent>,
    private toast: NbToastrService,
    private route: Router
  ) {}

  ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });
    if (!this.isEdit) {
      this.uploadThumbnail = true;
    } else {
      this.validPhoto = true;
    }
  }

  save() {
    this.isLoading = true;
    this.service.uploadFile(this.formData).subscribe((res) => {
      this.model.logo = res.fileName;
      this.service.post(this.model).subscribe((res) => {
        this.isLoading = false;
        this.diagRef.close('true');
        this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
      });
    });
  }

  getFormData(event) {
    this.formData = event;
    if (event) this.validPhoto = true;
  }

  close() {
    this.diagRef.close();
  }

  removePhoot() {
    this.uploadThumbnail = true;
    this.validPhoto = false;
  }

  updatePartner() {
    this.isLoading = true;
    let hasNewFile = false;
    this.formData.forEach((_) => {
      hasNewFile = true;
    });

    if (hasNewFile) {
      this.service.uploadFile(this.formData).subscribe((res) => {
        this.model.logo = res.fileName;

        this.update();
      });
    } else {
      this.update();
    }
  }

  update() {
    this.service.put(this.model.id, this.model).subscribe(
      (res) => {
        this.isLoading = false;
        this.diagRef.close('true');
        this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 });
      },
      (error) => {
        this.isLoading = false;
        this.toast.show('حدث خطأ أثناء التعديل ', '', { status: 'danger', duration: 3000 });
      }
    );
  }
}
